/* Settings → "Double-tap zoom" (every role, owner request 2026-10-14). On (the default): quick taps (the logo's 7 taps,
   −5 / +5 min, Now, Sync, Advent doors) never make the iPhone zoom the page; pinch to zoom always works (the viewport
   is never locked). Off: the iPhone's normal double-tap zoom. Saved per device (localStorage 'ot_block_dbltap' = '0'
   when Off). Applied as the class "no-dbltap" on <html>, which carries the touch-action: manipulation rules (style.css);
   index.html starts with the class, so there is no zoomable moment before this runs. */
const KEY = 'ot_block_dbltap';
export function blockDblTap(): boolean { try { return localStorage.getItem(KEY) !== '0'; } catch { return true; } }
export function applyDblTap() { document.documentElement.classList.toggle('no-dbltap', blockDblTap()); }
export function setBlockDblTap(on: boolean) {
  try { if (on) localStorage.removeItem(KEY); else localStorage.setItem(KEY, '0'); } catch { /* private mode */ }
  applyDblTap();
}
export function dblTapCard(): string {
  const on = blockDblTap();
  return `<div class="card" id="dblTapCard">
    <h2>Double-tap zoom</h2>
    <label class="h-switch" style="display:inline-flex; align-items:center; gap:10px; font-weight:600; cursor:pointer;">
      <span>Block double-tap zoom:</span>
      <input type="checkbox" class="switch" id="blockDblTap" ${on ? 'checked' : ''}><span id="blockDblTapLabel">${on ? 'On' : 'Off'}</span></label>
    <p class="muted-text" style="margin-top:8px;">On: tapping quickly (e.g. the logo, −5 min) never zooms the page. Pinch to zoom always works.
      Off: the iPhone's normal double-tap zoom. Saved on this device.</p>
  </div>`;
}
export function wireDblTapCard() {
  const sw = document.getElementById('blockDblTap') as HTMLInputElement | null;
  if (sw) sw.onchange = () => {
    setBlockDblTap(sw.checked);
    const l = document.getElementById('blockDblTapLabel'); if (l) l.textContent = sw.checked ? 'On' : 'Off';
  };
}
